// Message Mutations
export const ADD_ERROR = 'ADD_ERROR';
export const ADD_SUCCESS = 'ADD_SUCCESS';
export const REMOVE_ERROR = 'REMOVE_ERROR';
export const REMOVE_SUCCESS = 'REMOVE_SUCCESS';

// Session Mutations
export const SET_USER = 'SET_USER';
